import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DilysuService } from 'src/app/craidd/gwasanaethau/defnyddiwr/dilysu.service';
import { IaithStorfaService } from 'src/app/craidd/gwasanaethau/iaith/iaith-storfa.service';
import { environment } from 'src/environments/environment';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'app-dilysu-ailgyfeirio',
    templateUrl: './dilysu-ailgyfeirio.component.html',
    styleUrls: ['./dilysu-ailgyfeirio.component.scss'],
    imports: [MatProgressBar]
})
export class DilysuAilgyfeirioComponent implements OnInit {

    constructor(private dilysuService: DilysuService, private router: Router, private iaithStorfaService: IaithStorfaService) { }

    ngOnInit() {
        this.dilysuService.dilysu().then(() => {

            const iaith = this.iaithStorfaService.nol('iaith');

            let urlRedirect = 'cy';

            if (iaith === environment.iaith.saesneg) {
                urlRedirect = 'en';
            }

            this.router.navigate([urlRedirect]);
        });
    }
}
